import React from 'react'
import { Box, Text, Stack } from '@chakra-ui/react'
import { numberToDollars } from '../../utils/numberToCurrency'
import { TransferFeesType, TransferFeeLabel, TransferFeeDescriptionType } from '../TransferFees/types'
import { isEmpty } from 'lodash'
export interface ModalTransferFeesPreviewProps {
  fees: TransferFeesType
}

const ModalTransferFeesPreview = ({ fees }: ModalTransferFeesPreviewProps) => {
  return (
    <Stack spacing={4}>
      <Stack direction='row' w='100%'>
        <Box data-testid='feeAmount'>
          <Text fontWeight='bold'>Fees</Text>
          {isEmpty(fees) && <Text> No fees. (Fees may be assessed during review.) </Text>}
          {!isEmpty(fees) &&
            Object.entries(fees).map((fee) => {
              const [feeKey, feeValue] = fee
              const { feeTotal, chargeCustomer } = feeValue
              return (
                <Text key={feeKey}>
                  {feeTotal &&
                    `${numberToDollars(feeTotal)} |
                      ${TransferFeeLabel[feeKey as TransferFeeDescriptionType]} |
                      ${chargeCustomer ? 'Charge to customer' : 'Charge to correspondent'}`}
                </Text>
              )
            })}
        </Box>
      </Stack>
    </Stack>
  )
}

export default ModalTransferFeesPreview
